import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { getIsFeedbackPageOpen } from '@wix/da-shared-react/pkg/SiteHeader/redux/selectors';
import { appLoaded } from '../../actions/app';
import { Props } from './App';
import { AppState } from '../../types/store';
import { getCurrentItem } from '@wix/da-shared-react/pkg/Duperbrowse/redux/selectors';

type StateProps = Pick<
  Props,
  'environment' | 'deviation' | 'isFeedbackPageOpen'
>;
type DispatchProps = Pick<Props, 'appLoaded'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> =
  state => ({
    environment: state.environment.type,
    deviation: getCurrentItem(state as any),
    isFeedbackPageOpen: getIsFeedbackPageOpen(state),
  });

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  appLoaded,
};

export default connect(mapStateToProps, mapDispatchToProps);
